import { queue } from "./queue";
import { useQueueState } from "./state";

const changes = (n: number) => (n === 1 ? "1 wijziging" : `${n} wijzigingen`);

/** Indicator in de kopbalk (SPEC §11): "3 wijzigingen wachten op verbinding". */
export function OfflineBadge() {
  const s = useQueueState();
  let text = "";
  if (s.needsLogin && s.pending) text = `Log opnieuw in om ${changes(s.pending)} te versturen`;
  else if (s.pending && s.storageProblem && !s.syncing)
    text = `${changes(s.pending)} ${s.pending === 1 ? "wacht" : "wachten"}: de opslag blokkeert foto-uploads (meld dit bij een beheerder)`;
  else if (s.pending && s.syncing && !s.offline) text = `${changes(s.pending)} versturen…`;
  else if (s.pending) text = `${changes(s.pending)} ${s.pending === 1 ? "wacht" : "wachten"} op verbinding`;
  else if (s.offline) text = "Offline";
  return (
    <span
      className="offline-badge"
      role="status"
      aria-live="polite"
      data-state={text ? (s.pending ? "pending" : "offline") : "ok"}
    >
      {text && (
        <>
          <span className="dot" aria-hidden="true" />
          {text}
          {s.pending > 0 && !s.syncing && !s.offline && !s.needsLogin && (
            <button type="button" className="btn small" onClick={() => void queue.flush()}>
              Opnieuw proberen
            </button>
          )}
        </>
      )}
    </span>
  );
}
